// reusable components
// ********************************* Package Imports *********************************
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// ********************************* Component Imports ********************************
import Table from "../../components/table/table";
import { CustomButton } from "../../components/buttons/button";
import TextIconInput from "../../components/custom-fields/input";
// ********************************* API Imports ********************************

// ********************************* Asset Imports ********************************
import SearchIcon from "../../assets/icons/search-icon.svg";
import { AiOutlinePlus } from "react-icons/ai";
import EditIcon from "../../assets/icons/edit.png";
import DeleteIcon from "../../assets/icons/trash.png";

// Current Page Imports
import { FetchRoleListAPI,FetchModuleListAPI,updateRoleById} from "../../redux/slices/role.slice";
import { debounce} from "../../utils/redirections";
import { RolesPopup } from "./roleandaccess";
import { ConfirmPopup } from "../../components/model-popup/confirmation-popup";
// import toast from "react-hot-toast";
import { toast } from "react-toastify"
import { DeleteMultipleRoleAPI,RoleDeleteAPI } from "../../api/delete";
import { RolePutStatusAPI } from "../../api/update";
import { WordTitle } from "../../utils/commonFunction";

// ********************************* inter face  ********************************
import { ChildProps } from "../../utils/types/interFace";
import { ToggleButton } from "../../components/input-fields/toggle-button";

const RolePage = ({filteredAccess}:ChildProps) => {
  const dispatch:any = useDispatch();
  const RoleListData = useSelector((state: any) => state?.RoleList?.RoleList || []);
  const ModuleListData = useSelector((state: any) => state?.RoleList?.ModuleList || []);
  const userAccess = filteredAccess.length !== 0 ? filteredAccess[0] : {}
  const [showDeleteModel, setShowDeleteModel] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [limit, ] = useState<number>(15);
  const [search, setSearch] = useState<string>("");
  const [ViewDetails, setViewDetails] = useState<any>({});
  const [loader, setLoader] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modelTitle, setModelTitle] = useState<string>("");
  const [viewPopup, setViewPopup] = useState<boolean>(false);
  const [totalResults, ] = useState<number>(0);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const handleSearch = useCallback(debounce(setSearch, 500), []);
  const [showSearch, setShowSearch] = useState<string>(""); // Show search data
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [multiDelete, setMultiDelete] = useState<any>(false);

  // table
  const [sort,setSort] = useState('')
  const [sortDir,setSortDir] = useState('asc')
  const [,setTotalPage] = useState(0);
  const [,setTotalRecord] = useState(0);
  

  const handleModuleListData = (params: any = {}) => {
      const apiParam = { page: 1, limit: 100 }
      dispatch(
        FetchModuleListAPI(apiParam)
      ).then((res: any) => {
        console.log('')
      });
   };

  const handleRoleListData = (params: any = {}) => {
      const apiParam = {page:page,limit:limit,search_value:search,sort_by:sort,sort_dir:sortDir}
      if ('page' in params){
        apiParam['page'] = params['page']
        setPage(params['page'])
      } else if ('sort' in params) {
        apiParam['sort_by'] = params['sort'];
        apiParam['sort_dir'] = params['sortDir'];
        apiParam['page'] = 1
        setSort(params['sort'])
        setSortDir(params['sortDir'])
        setPage(1)
      } 
      if (apiParam['page'] === 1){
        setLoader(true)
        setSelectedRows([]);
      }
      dispatch(
        FetchRoleListAPI(apiParam)
      ).then((res: any) => {
        setTotalPage(res?.payload?.result?.total_pages);
        setTotalRecord(res?.payload?.result?.total_count);
        setLoader(false);
      });
   };

  const handleNextPage = () =>{
    handleRoleListData({page:page+1})
  }

  const handleMultiDelete = async () => {
      setButtonLoader(true);
      const selectedIds = selectedRows.map((row: any) => row?.id);
      const deleteParam = { role_list : selectedIds };
      await DeleteMultipleRoleAPI(deleteParam).then(async (res: any) => {
        setShowDeleteModel(false);
        if (res?.success) {
          setSelectedRows([]);
          toast.success(res?.message);
          handleRoleListData({page:1})
          setMultiDelete(false)
        } else {
          toast.error(res?.message || res?.detail?.message || "role delete failed");
        }
        setButtonLoader(false);
      });
    };
  
    const handleDelete = async () => {
      setButtonLoader(true);
      await RoleDeleteAPI(ViewDetails?.id).then((res: any) => {
        setShowDeleteModel(false);
        if (res?.success) {
          handleSearch([]);
          setViewDetails({});
          toast.success(res?.message);
          handleRoleListData({page:1})
          setMultiDelete(false)
        } else {
          toast.error(res?.message || res?.detail?.message || "mapping delete failed");
        }
        setButtonLoader(false);
      });
    };

    const handleUpdateStatus = async(e:any,id:any)=>{
      setLoader(true)
      const is_active = e.target.checked
      await RolePutStatusAPI(id,{is_active:is_active})
      .then((res: any) => {
        if(res?.success){
            dispatch(updateRoleById({ id: id, data: { is_active: is_active } }));
            toast.success(res.data?.message || "Update Status successfully")
        } else{
          toast.error(res?.message || res?.detail?.message ||"Update status failed");
        } 
      });
      setLoader(false)
    }

  
  // ************************** use effect  ************************
    useEffect(() => {
      handleRoleListData();
      handleModuleListData();
    }, []);
  
    useEffect(() => {
      handleRoleListData({page:1})
    }, [search]);
  
    useEffect(() => {
        handleSearch(showSearch);
      }, [showSearch]);

  return (
    
    <div className="border border-gray-200  bg-white rounded-lg ">

      <div className=" rounded-t-lg flex justify-between items-center p-4  ">
        
        <div>
            <h2 className="text-base font-semibold text-[#202A2B]">Role Settings</h2>
            <p className="text-sm text-gray-600">Add and update roles and access.</p>
        </div>

       <div className="flex items-center">
          <TextIconInput
            placeholder="Search"
            divStyle="max-w-[220px] me-2"
            onChange={(e: any) => {
              setShowSearch(e.target.value);
            }}
            inputStyle="w-full rounded-[8px] pr-[35px] "
            icon={SearchIcon}
            value={showSearch}
            setShowSearch={setShowSearch}
            clearSearch={handleSearch}
            iconStyle="w-[18px] h-[18px] top-[12px] right-[10px]"
          />
         {userAccess?.write_access && (
          <CustomButton
            buttonName="Add"
            primary={true}
            buttonStyle="text-white text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
            isFront
            onClick={() => {
              setModelTitle("Add New Role");
              setShowModal(true);
            }}
            icon={<AiOutlinePlus size={18} />}
            iconStyle="mr-[8px] font-semibold"
          />
        )}
        </div>

     


      </div>

      
        <div className="px-4">
        <hr className="border-gray-300" />
          </div>    
      
      <div className=" p-[16px] bg-white rounded-lg">
        

        

        <Table
          loading={loader}
          showCheckbox={userAccess.delete_access}
          setSelectedRows={setSelectedRows}
          MultiDeletedFucn={() => {
            setMultiDelete(true);
            setTimeout(() => {
              setShowDeleteModel(true);
            }, 10);
          }}
          hasNextPage = {page < totalResults}
          selectedRows={selectedRows}
          data={RoleListData}
          tableScroll={"100%"}
          NextPageData = {handleNextPage}
          columns={ 
            [
              "Role name",
              "Status",
              "Update By",
              ...(userAccess.delete_access || userAccess.update_access ? ["Action"] : [])
            ]
           
          }
          sort={true}
          columnColSpans={[6, 1, 1, 1]}
          sortTitleKeys={{ "Role name": "role_name", "Status": "is_active", "Update By": "user_last_name" }}
          handleSortfunc={(key: any, value: any) => {
            handleRoleListData({sort:key,sortDir:value})
          }}
          scopedSlots={{
            "Role name": ({ row }: any) => (
              <td colSpan={6} title={row?.first_name || ""}>
                <div className=" max-w-[500px] truncate cursor-default">
                  {row?.role_name ? WordTitle(row?.role_name)  : ""}
                </div>
              </td>
            ),
            Status: ({ row }: any) => (
              <td colSpan={1} title={row?.last_name || ""}>
                <div className=" max-w-[500px] truncate cursor-default">
                  <ToggleButton
                      onChange={(e: any) => {
                        if(userAccess.update_access){
                          handleUpdateStatus(e,row.id)
                        }
                      }}
                      value={row?.is_active}
                      disabled = {!userAccess.update_access}
                      toggleStyle="w-[36px] h-[20px] after:h-[16px] after:w-[16px] after:top-[2px]"
                    />
                </div>
              </td>
            ),
           
            
            "Update By": ({ row }: any) => (
              <td colSpan={1}>
                <div className="max-w-[150px] truncate cursor-default">
                 {(row?.updated_by_last_name || row?.updated_by_first_name) && (
                    <>
                      {row?.updated_by_last_name}, {row?.updated_by_first_name}
                    </>
                  )
                  }
                </div>
              </td>
            ),
            Action: ({ row }: any) => (
              <td colSpan={1} onClick={(e: any) => e.stopPropagation()}>
                {selectedRows?.length > 1 ? null : (
                  <div className="flex gap-[16px] items-center justify-center pr-[4px]">
                    {
                        userAccess.update_access && 
                      <img
                        src={EditIcon}
                        alt="Edit"
                        className="cursor-pointer w-[18px] h-[18px]"
                        onClick={() => {
                          setViewDetails(row);
                          setModelTitle("Edit Role");
                          setShowModal(true);
                        }}
                        />
                    }

                      {
                        userAccess.delete_access && 
                        <img
                          src={DeleteIcon}
                          onClick={async () => {
                            setShowDeleteModel(true);
                            setMultiDelete(false)
                            setViewDetails(row);
                          }}
                          alt="Delete"
                          className="cursor-pointer w-[18px] h-[18px]"
                        />
                      }


                  </div>
                )}
              </td>
            ),
          }}
        />
        

        
        {showModal ?
          <RolesPopup
            modules={ModuleListData}
            showModal={showModal}
            setShowModal={setShowModal}
            handleClose={() => {
              setViewDetails({});
              setShowModal(false);
              setViewPopup(false);
            }}
            title={modelTitle}
            setTitle={setModelTitle}
            viewPopup={viewPopup}
            poupDetails={ViewDetails}
            setPoupDetails={setViewDetails}
            rolesAccess={userAccess}
            afterSubmitModalForm={()=>{
              handleRoleListData({page:1})
            }}
          />
          : null}
        <ConfirmPopup showModal={showDeleteModel} icon>
          <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
            Delete Role?
          </div>
          <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
            You are about to delete{" "}
            <span className="font-semibold">
              {multiDelete
                ? `${selectedRows?.length} role`
                : `“${ViewDetails?.role_name}”`}
            </span>
            <br />
            Are you sure you want to continue?
          </div>
          <div className="flex justify-center gap-[16px] items-center w-full">
            <CustomButton
              buttonName="No, Keep it"
              primary={false}
              buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
              disable={buttonLoader}
              onClick={() => {
                setMultiDelete(false);
                setShowDeleteModel(false);
                setViewDetails({});
              }}
            />
            <CustomButton
              buttonName="Yes, Delete !"
              buttonStyle="w-full text-white bg-[#D41E1E] hover:bg-[#B51C1C] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
              loader={buttonLoader}
              disable={buttonLoader}
              loaderStyle="w-full bg-[#D41E1E]/80  py-[13px] "
              onClick={() => {
                multiDelete ? handleMultiDelete() : handleDelete();
              }}
            />
          </div>
        </ConfirmPopup>
      </div>
    </div>
  );
};

export default RolePage;
